import React, { useEffect, useState } from 'react';
import { ReactComponent as LocationIcon } from '../../assets/img/icons-storm/location.svg';
import { ReactComponent as SourceIcon } from '../../assets/img/modal/source.svg';
import { StormReport, StormReportsService } from '../../services/stormReports/stormReports';
import ClipLoader from 'react-spinners/ClipLoader';
import "./StormReportsContent.css";

interface StormReportsContentProps {
    report: StormReport
}

interface ReportContent {
    city: string,
    county: string,
    date: string,
    time: string,
    details: string,
    magnitude?: string,
    source?: string,
    state: string,
    type: string,
}

const StormReportsContent = ({ report }: StormReportsContentProps) => {

    const [reportContent, setReportContent] = useState<null | ReportContent>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const service = new StormReportsService();

    const init = () => {
        const result: ReportContent = service.getReportContent(report.text);
        setReportContent(result);
        setIsLoading(false);
    };

    useEffect(() => {
        init();
    }, []);

    if (isLoading) {
        return (
            <div className={'load-content'}>
                <ClipLoader
                    color={'#313638'}
                    loading={true}
                    size={35}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
            </div>
        );
    }

    return (
        <div className="modal-content-wrapper">
            <div className='storm-modal-infobox'>
                <div className='storm-modal-infobox-top'>
                    <img
                        src={report.icon.url}
                        alt="Storm Report"
                        width={50}
                        height={50}
                    />
                    <div>
                        <p className='storm-modal-infobox-heading'>{reportContent?.type}</p>
                        <div className='storm-modal-infobox-subhead'>
                            <LocationIcon />
                            <p>{reportContent?.city}</p>
                        </div>
                    </div>

                </div>
                <div className='storm-modal-infobox-bottom'>
                    <div className='storm-modal-infobox-bottom-date'>
                        <span className='storm-modal-infobox-bottom-title'>
                            Date:
                        </span>
                        <span className='storm-modal-infobox-bottom-value'>
                            {reportContent?.date}
                        </span>
                    </div>
                    <div className='storm-modal-infobox-bottom-time'>
                        <span className='storm-modal-infobox-bottom-title'>
                            Time:
                        </span>
                        <span className='storm-modal-infobox-bottom-value'>
                            {reportContent?.time}
                        </span>
                    </div>
                </div>
            </div>
            <div className='modal-more-details'>
                <h2 className='modal-more-details-heading'>More Details</h2>
                {
                    reportContent?.magnitude && (
                        <div className='modal-more-details-row'>
                            <p className='modal-more-details-row-title'>
                                Magnitude:
                            </p>
                            <p className='modal-more-details-row-value'>
                                {reportContent?.magnitude}
                            </p>
                        </div>
                    )
                }
                {
                    reportContent?.source && (
                        <div className='modal-more-details-row'>
                            <p className='modal-more-details-row-title'>
                                Source:
                            </p>
                            <p className='modal-more-details-row-value modal-details-source'>
                                <SourceIcon />
                                <span>
                                    {reportContent?.source}
                                </span>
                            </p>
                        </div>
                    )
                }
                {
                    reportContent?.details && (
                        <div>
                            <p className='modal-more-details-row-title'>
                                Description:
                            </p>
                            <p className='modal-more-details-row-value'>
                                {reportContent?.details}
                            </p>
                        </div>
                    )
                }
            </div>
        </div>
    );
}

export default StormReportsContent;